import { useQuery } from '@apollo/client';
import { useContext } from 'react';
import { Maybe, Note, Result, SkHitResults } from 'sr-types/lib/search/v1/graphql';
import { UserContext } from '../../auth/UserContext';
import { FETCH_POLICY_CONFIG, FILTER_IDENTIFIERS } from '../../constants/constants';
import { searchClient, slimResultsQuery } from '../../list/slimQuery';

type SearchNotesResult = {
    results?: Maybe<Omit<Result, 'hits'>> & {
        hits?: Maybe<Omit<SkHitResults, 'items'>> & {
            items?: Maybe<Array<Maybe<Note>>>;
        };
    };
};

export const useSearchNotes = (linkedEntityId: string, skip: boolean = undefined, selectedTags: string[] = []) => {
    const { activeOrganizationAccount } = useContext(UserContext);

    const {
        data: noteData,
        loading: isNoteLoading,
        error: noteFetchError,
        refetch: noteRefetch
    } = useQuery<SearchNotesResult>(slimResultsQuery('Note', true), {
        context: {
            headers: {
                ownerId: activeOrganizationAccount
            }
        },
        variables: {
            filters: [
                {
                    identifier: 'entity',
                    value: 'Note'
                },
                {
                    identifier: 'entityId',
                    value: linkedEntityId
                },
                ...selectedTags.map((tag) => ({ identifier: FILTER_IDENTIFIERS.labels, value: tag }))
            ],
            page: {
                from: 0,
                size: 100
            }
        },
        client: searchClient,
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy,
        notifyOnNetworkStatusChange: true,
        skip: skip
    });

    return { noteData, isNoteLoading, noteFetchError, noteRefetch };
};